import { useCallback, useRef } from "react";
import useAuthorizedUrl from "@/features/widgets/hooks/useAuthorizedUrl.tsx";
import DataHelper from "@/utils/dataHelper.tsx";
import { Product } from "@/features/widgets/components/Comparison/types/ComparisonTypes";

const useTrackEvent = () => {
  const analyticsUrl = useAuthorizedUrl(`/api/v1/analytics`);
  const analyticsUrlRef = useRef(analyticsUrl);
  analyticsUrlRef.current = analyticsUrl;

  return useCallback((action: string, type: string, value: string|null, products: Product[] = []) => {
    DataHelper.post(
      analyticsUrlRef.current,
      JSON.stringify({
        action: action,
        type: type,
        value: value,
        urls: products.map(product => product.url),
      }),
    );
  }, []);
}

export default useTrackEvent;
